import { render } from "./RestrictedMessage.vue?vue&type=template&id=5d8ef8de&scoped=true"
import script from "./RestrictedMessage.vue?vue&type=script&lang=js"
export * from "./RestrictedMessage.vue?vue&type=script&lang=js"

import "./RestrictedMessage.vue?vue&type=style&index=0&id=5d8ef8de&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8ef8de"]])

export default __exports__